<template>
  <v-container>
    <v-flex>
      <v-data-iterator 
          :items="richiesteInSospeso" 
          row
          wrap
          class="elevation-0"
          content-class="v-list--two-line"
          content-tag="v-list">
          <v-flex
            slot="no-data"
            align-self-center
            class="title font-weight-light grey--text pa-3 text-xs-center"
          >Non ci sono richieste!</v-flex>
          <template slot="item" slot-scope="props">
            <v-list-tile>
              <v-list-tile-content class="px-2">
                <div class="body-2 font-weight-medium">{{props.item.nominativo}} - {{props.item.causale}}</div>
                <div class="body-1">
                  <template v-for="(item,i) in creaIcone(props.item.categorie)">
                    <div :key="i" class="px-2" style="display: inline-grid;">
                      <v-icon
                        size="14"
                        color="#01579b"
                        style="padding:0 5px 0 5px;"
                      >{{ item.icon }}</v-icon>
                      <span class="caption tree--text">{{item.descrizione}}</span>                      
                    </div>
                  </template>
                </div>
                <v-divider class="my-1" style="width: 100%"></v-divider>
              </v-list-tile-content>
              <v-list-tile-action class="align-center">
                <div class="caption font-weight-regular">{{ dataFormat(props.item.data) }}</div>
                <div>
                <v-btn icon flat @click="accettaRichiestaHandler(props.item)" class="mr-2">
                  <v-icon color="green">far fa-check-circle</v-icon>
                </v-btn>
                <v-btn icon flat @click="rifiutaRichiestaHandler(props.item)">
                  <v-icon color="error">fas fa-ban</v-icon>
                </v-btn>
                </div>
              </v-list-tile-action>
            </v-list-tile>
          </template>
        </v-data-iterator>
    </v-flex>

    <v-dialog v-model="dialog" max-width="400px" persistent>
      <v-card>
        <v-flex v-if=" conferma == true">
          <v-toolbar color="secondary" dense>
            <v-toolbar-title class="primarytext--text">Accetta richiesta</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              class="ma-0"
              size="25"
              flat
              icon
              dark
              color="transparent"
              @click="chiudiHandler"
            >
              <v-icon size="30" color="#bfcbd9">close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-card-title style="font-size: 17px;">Conferma o modifica le categorie per  <br> {{singleElement.nominativo}}</v-card-title>
            <!--<v-card-title primary-title>{{singleElement.nominativo}}</v-card-title>-->

            <v-select
              :items="categorie"
              item-text="descrizione"
              item-value="id"
              multiple
              clearable
              chips
              color="tree"
              label="Categorie"
              v-model="categorie_scelte"
            >
              <template slot="selection" slot-scope="{ item, index }">
                <span>
                  <v-icon small color="tree" left>{{ item.icon }}</v-icon>
                </span>
              </template>
              <template slot="item" slot-scope="{ item }">
                <v-icon small color="grey" left>{{ item.icon }}</v-icon>
                {{ item.descrizione.toUpperCase() }}
              </template>
            </v-select>

            <v-btn color="secondary" :disabled="!attiva" dark @click="confermaHandler">Salva</v-btn>
          </v-card-text>
        </v-flex>
        <v-flex v-if=" elimina == true">
          <v-toolbar color="secondary" dense>
            <v-toolbar-title class="primarytext--text">Elimina richiesta</v-toolbar-title>
            <v-btn
              class="ma-0"
              size="25"
              absolute
              flat
              icon
              right
              dark
              color="transparent"
              @click="chiudiHandler"
            >
              <v-icon size="30" color="#bfcbd9">close</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-card-title
              style="font-size: 17px;"
            >Sei sicuro di voler eliminare la richiesta di {{singleElement.nominativo}}?</v-card-title>

            <v-btn color="error" dark @click="eliminaHandler(singleElement.login)">Elimina</v-btn>
          </v-card-text>
        </v-flex>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  name: "tab-richieste",
  components: {},
  props: {
    richiesteInSospeso: {
      type: Array,
      required: true
    },
    categorie: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      tabs: "richieste",
      categorie_scelte: [],
      dialog: false,
      conferma: false,
      elimina: false,
      singleElement: {},
      pagination: {
        sortBy: 'data'
      },
      headers: [
        {
          text: "NOMINATIVO",
          sortable: true,
          width: '200px',
          value: "nominativo"
        },
        {
          text: "DATA",
          sortable: true,
          value: "data"
        },
        {
          text: "CAUSALE",
          sortable: true,
          value: "categorie"
        },
        {
          text: "VERIFICA",
          sortable: false,
          width: '150px',
          value: ""
        }
      ]
    };
  },
  computed: {
    nomi_categorie: {
      get() {
        return this.singleElement.categorie
          ? this.singleElement.categorie.split(",")
          : [];
      },
      set(val) {
        this.singleElement.categorie = val.join(",");
      }
    },
    attiva() {
      if (this.categorie_scelte.length > 0) {
        return true;
      } else return false;
    }
  },
  created() {
  },
  beforeCreate() {
    if (!this.$store.hasModule("gestione")) {
      this.$store.registerModule("gestione", GestioneAdmin);
    }
  },
  methods: {
    creaIcone(vettore) {
      return this.categorie
        .filter(ct => {
          return vettore && vettore.split(",").includes(ct.id);
        })
        // .map(ct => ct.icon);
    },
    selezionaIcone(categorie) {
      var s = [];
      for (var i = 0; i < categorie.length; i++) {
        if (v[i] == this.categorie[j].id) {
          s.push(categorie[i].icon);
        }
      }
      return s;
    },
    accettaRichiestaHandler(item) {
      this.singleElement = item;
      this.categorie_scelte = !!item.categorie ? item.categorie.split(',') : []
      this.elimina = false;
      this.dialog = true;
      this.conferma = true;
    },
    rifiutaRichiestaHandler(item) {
      this.singleElement = item;
      this.categorie_scelte = [];
      this.conferma = false;
      this.dialog = true;
      this.elimina = true;
    },
    confermaHandler() {
      this.singleElement.categorie = this.categorie_scelte.join(",");
      this.$store.dispatch("gestione/confermaAutorizzazione", {
        item: this.singleElement
      });
      this.dialog = false;
      this.conferma = false;
    },
    eliminaHandler() {
      this.singleElement.categorie = this.categorie_scelte.join(",");
      this.$store.dispatch("gestione/eliminaAutorizzazione", {
        item: this.singleElement
      });
      this.dialog = false;
      this.elimina = false;
    },
    dataFormat(data) {
      return !data ? data : this.$moment(data).format("DD/MM/YYYY");
    },
    chiudiHandler(data) {
      this.singleElement = {};
      this.categorie_scelte = [];
      this.dialog = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.v-list__tile--active {
  .v-icon {
    color: #01579b !important;
  }
}
</style>



// WEBPACK FOOTER //
// modules/Home/views/src/components/TabRichieste.vue